import { composeValidators } from '@reliance/forms-js/lib/validation';
import React from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import FormGroup from 'react-bootstrap/FormGroup';
import Row from 'react-bootstrap/Row';
import { Field } from 'react-final-form';
import { states, statesAndProvinces } from '../common/states';

type StatesProps = {
  name: string;
  label: string|JSX.Element;
  id?: string;
  placeholder?: string;
  validationRules?: any[];
  helperText?: string;
  disabled?: boolean;
  abbreviations?: boolean;
  includeEmpty?: boolean;
  includeCanada?: boolean;
};

type InlineStatesProps = StatesProps & {
  labelCols: number;
};

export const States: React.FC<StatesProps> = (props) => {
  const includeCanada = props.includeCanada !== false;
  const options = includeCanada ? statesAndProvinces : states;

  return (
    <Field
      name={props.name}
      validate={composeValidators(props.validationRules || [])}>
      {({ input, meta }) => (
        <FormGroup>
          <label>{props.label}</label>

          <Field
            id={props.id}
            className={`form-control ${meta.touched && meta.error ? 'has-error' : ''}`}
            component="select"
            disabled={meta.submitting || props.disabled}
            {...input}>
            {props.includeEmpty && <option></option>}
            {options.map((s) =>
              <option key={`state-${s.abbr}-${props.name}`} value={s.abbr}>{props.abbreviations ? s.abbr : s.name}</option>
            )}
          </Field>
          {((meta.error && meta.touched) || props.helperText) &&
            <span className="help-block has-error">{meta.error && meta.touched ? meta.error : props.helperText}</span>
          }
        </FormGroup>
      )}
    </Field>
  );
};

export const InlineStates: React.FC<InlineStatesProps> = (props) =>
  <Field
    name={props.name}
    validate={composeValidators(props.validationRules || [])}>
    {({ input, meta }) => (
      <FormGroup as={Row}>
        <Form.Label column sm={props.labelCols}>{props.label}</Form.Label>

        <Col>
          <Field
            id={props.id}
            className={`form-control ${meta.touched && meta.error ? 'has-error' : ''}`}
            component="select"
            disabled={meta.submitting || props.disabled}
            {...input}>
            {statesAndProvinces.map((s) =>
              <option key={`state-${s.abbr}-${props.name}`} value={s.abbr}>{s.name}</option>
            )}
          </Field>
          {((meta.error && meta.touched) || props.helperText) &&
            <span className="help-block has-error">{meta.error && meta.touched ? meta.error : props.helperText}</span>
          }
        </Col>
      </FormGroup>
    )}
  </Field>